import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

function SystemRoleComponent(props) {
  const { FetchDetails, location } = props;
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [positions, setPositions] = React.useState([]);
  const [locationInfo, setLocationInfo] = React.useState();
  const [checkedList, setCheckedList] = React.useState([]);

  const permissionList = [
    {
      label: "Dashboard",
      value: "dashboard",
    },
    {
      label: "Approve Leave",
      value: "approve-leave",
    },
    {
      label: "Annual leave",
      value: "annual-leave",
    },
    {
      label: "Company Manuals",
      value: "company-manuals",
    },
    {
      label: "Project Management",
      value: "project-management",
    },
    {
      label: "Technology",
      value: "technology",
    },
    {
      label: "Meeting Management",
      value: "meeting-management",
    },
    {
      label: "Product Management",
      value: "product-management",
    },
    {
      label: "Team management",
      value: "team-management",
    },
    {
      label: "Recruitment Module",
      value: "recruitment-module",
    },
    {
      label: "Finance Dashboard",
      value: "finance-dashboard",
    },
    {
      label: "View To All Project",
      value: "view-all-project",
    },
    {
      label: "View To All Product",
      value: "view-all-product",
    },
    {
      label: "System Settings",
      value: "system-settings",
    },
    {
      label: "Reports",
      value: "reports",
    },
  ];
  useEffect(() => {
    setLocationInfo(location?.state);
  }, [location?.state]);
  const className = `  'border-0' px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`;

  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp.status) {
      const positionList = resp?.data?.list?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPositions(positionList);
      if (!locationInfo?.positionId)
        setLocationInfo({
          ...positionList[0],
          positionId: positionList[0]?.value,
        });
    }
  };

  useEffect(() => {
    loadPositions().then();
  }, []);

  const columns = [
    // {
    //     name: "StaffPosition.name",
    //     label: "Position ID",
    //     // options: {
    //     //     customBodyRenderLite: (id, index) => {
    //     //         return (
    //     //         <span
    //     //           className="text-bold"
    //     //         >
    //     //         {list[index]?.Positions?.length()}
    //     //         </span>
    //     //       );
    //     //     },
    //     //   },
    // },
    {
      name: "name",
      label: "Name",
    },

    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            onDelete={() => {
              setDeleteOpen(true);
              setId(v);
            }}
          />
        ),
      },
    },
  ];

  const onSuccess = () => setCount((v) => v + 1);
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/role/position-permission/delete/${id}`}
      />
      <FormDialog
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={
          open === 1
            ? "/api/role/position-permission/create"
            : `/api/role/position-permission/update/${id}`
        }
        title={open === 1 ? "Add New Permission" : "Edit Permission"}
        fields={[
          {
            name: "positionId",
            label: "Position",
            type: "select",
            values: positions,
            value: value["positionId"],
            required: true,
            setValue: (val) => setValue0("positionId", val),
          },
          {
            name: "name",
            label: "Name",
            value: checkedList,
            render: () => (
              <Box>
                {permissionList?.map((item) => (
                  <FormControl sx={{ m: 3 }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={item.label}
                            checked={checkedList.includes(item.value)}
                            onChange={() => {
                              const temp = [...checkedList];
                              // const newValue = { name: item.value, positionId: value['positionId'] }
                              if (!checkedList.includes(item.value)) {
                                temp.push(item.value);
                              } else {
                                let index = temp.indexOf(item.value);
                                if (index !== -1) {
                                  temp.splice(index, 1);
                                }
                              }
                              setCheckedList(temp);
                            }}
                          />
                        }
                        label={item.label}
                      />
                    </FormGroup>
                  </FormControl>
                ))}
              </Box>
            ),
          },
          // {
          //     name: "name",
          //     label: "Name",
          //     value: value['name'],
          //     values: permissionList,
          //     type: 'select',
          //     required: true,
          //     setValue: (val) => setValue0('name', val),
          // },
        ]}
      />

      <DatatableComponent
        onAddNew={() => {
          setOpen(1);
          setValue0("positionId", locationInfo?.value);
        }}
        processData={(data) => {
          setList(data.data);
          setCheckedList(data?.data?.map((item) => item?.name));
          return data;
        }}
        elevation={1}
        columns={columns}
        url={`/api/role/position-permission/list?count=${count}&${
          locationInfo ? `positionId=${locationInfo?.positionId}` : undefined
        }`}
        title={
          <>
            <div className="w-full">
              <Typography variant="h6">
                {locationInfo?.label
                  ? `System Permissions: ${locationInfo?.label}`
                  : "Position Permissions"}
              </Typography>
            </div>
            <div
              className="relative w-full"
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              <select
                placeholder={"Position"}
                className={className}
                value={locationInfo?.value}
                onChange={(e) => {
                  const info = positions?.find(
                    (item) => item.value === e.target.value
                  );
                  setLocationInfo({ ...info, positionId: e.target.value });
                }}
              >
                <option value="">-- select --</option>
                {positions?.map((item) => (
                  <option value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
          </>
        }
      />
    </div>
  );
}

export default SystemRoleComponent;
